import { gql } from 'graphql-tag';

export default gql`
  mutation CreateCustomerMessage($input: CreateCustomerMessage!) {
    createCustomerMessage(input: $input) {
      id
      status
      message
      scheduledAt
      audienceCount
      creditsRequired
    }
  }
`;